import { GenIcon } from '../helpers/IconBase.es.js';

const ProfileOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 12C9.533 12 7.517 9.985 7.517 7.517C7.517 5.049 9.533 3 12 3C14.467 3 16.483 5.015 16.483 7.483C16.483 9.951 14.467 12 12 12ZM19 21H5C4.45 21 4 20.55 4 20V19C4 16.8 5.8 15 8 15H16C18.2 15 20 16.8 20 19V20C20 20.55 19.55 21 19 21Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { ProfileOutlined };
